import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({
  name: 'HeroCarouselProgressOverlay',
})(({ breakpoints, typography: { pxToRem }, spacing }) => ({
  container: {
    position: 'absolute',
    inset: 'auto 0',

    [breakpoints.up('xs')]: { bottom: pxToRem(53) },
    [breakpoints.up('sm')]: { bottom: pxToRem(51.5) },
    [breakpoints.up('md')]: { bottom: pxToRem(53) },
    [breakpoints.up('lg')]: { bottom: pxToRem(68) },
    [breakpoints.up('xl')]: { bottom: pxToRem(74) },
  },
  progressBoxesWrapper: {
    display: 'flex',

    [breakpoints.up('xs')]: { gap: spacing(2) },
    [breakpoints.up('md')]: { gap: spacing(3) },
  },
}));

export default useStyles;
